import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { skelton } from '@/lib/css-lib'
import { useAccount } from '@/hooks/useAccount'
import BucketImageView from '../core/BucketImageView'

/**
 * アバター表示コンポーネント
 * @returns 
 */
const Avatar: React.FC = () => {
    const { isLoggedIn, account } = useAccount()
    const imageStyle = {
        borderRadius: "50%",
        width: "100%",
        height: "100%"
    };
    
    return (
        <Container to="/account">
            {
                (isLoggedIn && account) ?
                <>
                    <ImageArea>
                        <BucketImageView url={account?.avaterImage} imageStyle={imageStyle} shape="round" />
                    </ImageArea>
                    <Text>{account?.name}</Text>
                </> :
                <>
                    <Skelton />
                    <SkeltonText/ >
                </>
            }
        </Container>
    )
}

export default Avatar

const Container = styled(Link)`
    height: 105px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    border-bottom: ${(p) => p.theme.borders.thick};
    text-decoration: none;

    :hover {
        background-color: #eee;        
    }
`

const ImageArea = styled.div`
    width: 65px;
    height: 65px;
    margin-left: 15px;
`;

const Text = styled.div`
    max-width: 150px;
    max-height: 100%;
    margin-left: 15px;
    color: ${p => p.theme.colors.fore};
    overflow: hidden;

    :visited {
        color: ${p => p.theme.colors.fore};
    }
`;


const Skelton = styled.div`
    width: 65px;
    height: 65px;
    margin-left: 15px;
    border-radius: 50%;
    background-color: #ccc;
    animation: ${skelton};
`;

const SkeltonText = styled.div`
    width: 105px;
    height: 16px;
    margin-left: 15px;
    border-radius: 8px;
    animation: ${skelton};
`;